const translations = {
    'age.label': 'Age %d',
};

export default translations;
